import React, { useEffect, useState } from 'react';
import './contact.css';
import { Helmet } from 'react-helmet';
import { FaEnvelope, FaFacebookF, FaYoutube } from 'react-icons/fa';
import axios from 'axios';

const Contact = () => {
  const [metaTags, setMetaTags] = useState([]);

  useEffect(() => {
    document.title = "Contact Us - Funfillia";

    const fetchMetaTags = async () => {
      try {
        const res = await axios.get('https://api.funfillia.com/api/v2/website/metaTags/contact_us', {
          headers: {
            Accept: 'application/json',
            'Client-Domain':'www.funfillia.com',
          },
        });

        const htmlString = res.data?.metaTags || '';
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);
      } catch (err) {
        console.error("Error fetching contact page meta tags:", err);
      }
    };

    fetchMetaTags();
  }, []);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find(t => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - Funfillia</title>

        {/* General Meta */}
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />
        <link rel="canonical" href={window.location.href} />

        {/* Open Graph Meta */}
        <meta property="og:type" content={getMetaContent('property', 'og:type')} />
        <meta property="og:url" content={getMetaContent('property', 'og:url')} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />

        {/* Twitter Meta */}
        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
      </Helmet>

      <div className="contact-container">
        <div className="contact-card">
          <h1 className="contact-title">Get in Touch</h1>
          <p className="contact-subtitle">
            We're always here to help. Reach out through any of the methods below.
          </p>

          <div className="contact-info">
            <div className="info-box">
              <FaEnvelope className="icon" />
              <a href="mailto:info@funfillia.com">info@funfillia.com</a>
            </div>
          </div>

          <div className="socials">
            <a
              href="https://www.facebook.com/share/16Kxe1eCVp/"
              target="_blank"
              rel="noopener noreferrer"
              className="facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.youtube.com/@FUNFILLIA"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
